import { useCodeDownload } from '~/lib/hooks/useCodeDownload';
import { classNames } from '~/utils/classNames';

/**
 * "Download code" in the Code tab — hands the user a zip of their project.
 *
 * The zip is built server-side from the pod's workspace (or its snapshot), so it
 * carries every file, binaries and large files the editor's watcher skips
 * included. That takes a moment, hence the progress label.
 */
export function DownloadCodeButton() {
  const { download, busy, isFree, planUnknown, available } = useCodeDownload();

  return (
    <button
      type="button"
      onClick={download}
      disabled={busy || !available}
      title={isFree ? 'Downloading your code requires a plan' : 'Download this project as a zip'}
      className={classNames('ui-btn-ghost w-full justify-start px-2 py-1.5 text-[12px]', busy && 'text-primary')}
    >
      <span
        className={classNames(
          'text-[13px] flex-shrink-0',
          busy ? 'i-svg-spinners:ring-resize' : 'i-ph:download-simple',
        )}
      />
      {/* One flex item: ui-btn-ghost is a gap-1.5 flex, so a label split into
          fragments would get spaced like separate words. */}
      <span className="truncate">{busy ? 'Packaging…' : 'Download code'}</span>
      {isFree && !planUnknown && <span className="i-ph:lock-simple text-[11px] text-muted ml-auto flex-shrink-0" />}
    </button>
  );
}
